// extracted by mini-css-extract-plugin
module.exports = {"root":"new-label_root__kPoE7"};